import { ACFMediaFragment } from "@/fragments";
import { gql } from "@apollo/client";

export const NextUpQuery = gql`
  ${ACFMediaFragment}
  query GetNextUpPost($databaseId: ID!) {
    nextUpStory(postId: $databaseId) {
      uri
      featureData {
        sonicConnections {
          headline
          tracks {
            heroImage {
              ...ACFMedia
            }
          }
        }
      }
    }
  }
`;